/* global angular swal _*/
import './style.less';
import { findIndex } from 'lodash';

export default function($window, EventClass, $stateParams, $log, Swal, Upload, ProfileClass, ApiClass) {
  'ngInject';
  const vm = this;

  vm.$onChanges = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.routeParams = $stateParams;
  vm.resultsQueried = false;
  vm.pagination = {
    numPerPage: 11,
    currentPage: 1,
    setPage: pageNo => (vm.pagination.currentPage = pageNo)
  };

  vm.hasExternalWebinar = () => {
    return !!EventClass.externalWebinars(vm.event).length;
  };

  function errorSwal() {
    swal('Oops!', 'Looks like there was an error uploading your file. Try again', 'error');
  }

  function waitSwal(fileType) {
    swal({
      title: 'One Moment...',
      text: `We are uploading the ${fileType}...`,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  vm.uploadPdf = file => {
    if (!file) return;
    let Policy;
    vm.s3Policy(file)
      .then(({ data: { item } }) => {
        waitSwal('attendance sheet');
        Policy = item;
        return vm.uploadAttendanceSheet(Policy, file);
      })
      .then(() => vm.postEvent(Policy))
      .then(() => vm.updateEvent(Policy))
      .then(() => Swal.toast('Uploaded!'))
      .catch(error => {
        errorSwal();
        $log.error(error);
        throw error;
      });
  };

  vm.s3Policy = file => {
    return ApiClass.companiesIdTypePut(
      { manage: true, id: company_id, type: 'policies' },
      {
        policy: 'event',
        event_id: $stateParams.eventid,
        file_type: file.type,
        file_name: file.name
      }
    );
  };

  vm.uploadAttendanceSheet = (Policy, file) => {
    return Upload.upload({
      url: Policy.filePolicy.action,
      data: Policy.filePolicy.fields,
      file: file,
      method: 'POST',
      skipAuthorization: true
    });
  };

  vm.postEvent = Policy => {
    const event = {
      course_id: $stateParams.courseid,
      event_id: $stateParams.eventid
    };

    if (vm.location.primary) {
      event.attendance_url = Policy.link;
      event.pdf_uploaded = true;
    }

    if (!vm.location.primary) {
      const locations = vm.event.locations.filter(({ primary }) => !primary);
      const index = findIndex(locations, { location: vm.location.location });
      locations[index].attendance_url = Policy.link;
      locations[index].pdf_uploaded = true;
      event.locations = locations;
    }
    return ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event });
  };

  vm.updateEvent = Policy => {
    if (vm.location.primary) {
      vm.event.attendance_url = Policy.link;
      vm.event.pdf_uploaded = true;
    }
    vm.location.attendance_url = Policy.link;
    delete vm.fileToUpload;
    return;
  };

  vm.submit = (registrants, suppressEmail) => {
    return Swal.confirm(
      'Generate Certificate(s)?',
      'This will issue credit to the selected attendee(s) and generate a certificate of completion.'
    )
      .then(() => {
        const event_id = vm.event.event_id;
        const course_id = vm.event.course_id;

        const attendeeMap = {};

        const profile_uids = registrants.map(attendee => {
          const { profile_uid } = attendee;
          if (attendee.formData)
            attendee.hours_basic = attendee.formData.modifiedStates.reduce((obj, state) => {
              obj[state.reg_id] = state.hours;
              return obj;
            }, {});
          attendee.completed = _.sumBy(attendee.hours, 'credits') > 0;
          attendee.attended = true;
          attendee.redeemed = true;
          attendee.suppressCert = suppressEmail;
          attendee.sendCert = true;
          const param = angular.copy(attendee);
          delete param.formData;
          attendeeMap[profile_uid] = param;
          return profile_uid;
        });

        return ApiClass.eventsIdTypePatch(
          { id: event_id, type: 'attendees' },
          { profile_uids, attendeeMap },
          { queryParams: { manage: true } }
        );
      })
      .then(result => {
        if (result === 'cancel') return Promise.resolve(result);
        Swal.alert(
          'Certificate(s) Issued',
          "Attendees' status may take a couple minutes to update and a refresh is required.",
          'success'
        );
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.submitInstructor = function(instructorsRaw) {
    return Swal.confirm(
      'Generate Certificate(s)?',
      'This will issue credit to instructor(s) and generate a certificate of completion.'
    )
      .then(() => {
        const instructors = angular.copy(instructorsRaw);
        instructors.forEach(instructor => {
          const selected = instructor.selected;
          delete instructor.selected;

          if (!selected) {
            return;
          }

          if (instructor.formData)
            instructor.hours_basic = instructor.formData.modifiedStates.reduce((obj, state) => {
              obj[state.reg_id] = state.hours;
              return obj;
            }, {});
          delete instructor.formData;
          if (!instructor.experience) {
            const totalCredits = _.sumBy(instructor.hours, 'credits');
            instructor.attended = true;
            instructor.completed = totalCredits > 0;
          }
        });

        const attendees = angular
          .copy(instructors)
          .filter(({ experience }) => !experience)
          .map(instructor => {
            instructor.delivery_method = 4;
            return instructor;
          });

        const event = { event_id: vm.event.event_id, course_id: vm.event.course_id, instructors };

        // TODO: EventClass

        return ApiClass.eventsIdPatch({ id: vm.event.event_id, manage: true }, { event });
      })
      .then(() => Swal.toast('Certificate(s) Issued', 'success'))
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.view = url => $window.open(url, 'popup', 'width=750,height=500,left=10,top=150');

  function activate() {
    if (!vm.location) return;

    vm.registrants = [];
    vm.certificates = [];
    vm.attendees = [];

    angular
      .copy(vm.location.attendees)
      .filter(({ email }) => !!email)
      .forEach(attendee => {
        attendee.hours = attendee.hours || angular.copy(vm.event.hours) || [];
        attendee.hours_basic = attendee.hours_basic || angular.copy(vm.event.hours_basic) || [];

        if (attendee.completed) return vm.certificates.push(attendee);
        if (attendee.attended) return vm.attendees.push(attendee);

        // Note: reset hour infomation for non issue registrants
        vm.registrants.push({
          ...attendee,
          hours: angular.copy(vm.event.hours || []),
          hours_basic: angular.copy(vm.event.hours_basic || [])
        });
      });

    vm.activeTab = 0;

    vm.event.instructors = (vm.event.instructors || []).map(instructor => ({
      ...instructor,
      hours: instructor.hours || angular.copy(vm.event.hours)
    }));

    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/addCertificates/controller.js